module.exports = __webpack_public_path__ + "media/images/emblems/Erlenbach_ZH-coat_of_arms-1d6cdf3761b2665b11ca9c55ad5fa70b.svg";